import { displaySuccessNotification } from './displayNudosStandardNotifications';

interface ICopyClipboard {
  text: string;
  notificationMessage?: string;
}

/**
 * Copia el texto proporcionado al portapapeles del usuario.
 * Opcionalmente muestra una notificación de éxito.
 * @param text - Texto a copiar al portapapeles
 * @param notificationMessage - Mensaje opcional para mostrar en la notificación de éxito.
 *                              Si no se proporciona, no se muestra notificación.
 */
export const copyClipboard = async ({ text, notificationMessage }: ICopyClipboard): Promise<void> => {
  await navigator.clipboard.writeText(text);

  if (notificationMessage) {
    displaySuccessNotification({ customJSXMessage: <>{notificationMessage}</> });
  }
};
